// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
export const firebaseConfig = {
  apiKey: "AIzaSyBPTa8CLFTfu0yO_uHsml6OKviiS84_SZQ",
  authDomain: "escala-musica.firebaseapp.com",
  projectId: "escala-musica",
  storageBucket: "escala-musica.firebasestorage.app",
  messagingSenderId: "651214145064",
  appId: "1:651214145064:web:597457021c9bedd33fd71d"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Exporta para usarmos no app
export const auth = getAuth(app);
export const db = getFirestore(app);

auth.languageCode = 'pt';